<template>
  <div>
    <modal v-if="!acceptInvite" class="join-team-modal" @close="$emit('close')">
      <div slot="title">
        <h4>
          {{ $t('congratsParty') + ' 🎉' }}<br />
          {{ $t('youveJoinedTheXTeamOnClavo', { x: team.name }) }}
        </h4>
      </div>
      <div slot="body" class="join-team-body">
        <img :src="require('@/assets/illustrations/sloth-w-clock.svg')" />
        <div>
          {{ $t('fromNowOnYourWorkingSchedule') }}
        </div>
        <footer slot="footer" class="single-btn">
          <button class="clavo-button primary" @click="$emit('close')">
            {{ $t('goToDashboard') }}
          </button>
        </footer>
      </div>
    </modal>
    <modal v-else class="join-team-modal" @close="$emit('close')">
      <div slot="title">
        <h4>{{ $t('joinXTeam', { x: team.name }) }}</h4>
      </div>
      <div slot="body" class="join-team-body">
        <img :src="require('@/assets/illustrations/sloth-w-coffee.svg')" />
        <div>
          {{ $t('personHasInvitedYouToJoin', { person: 'Person' }) }} <span class="bold">{{ team.name }}</span> team.
        </div>
        <footer slot="footer">
          <button class="clavo-button secondary" @click="$emit('reject-invite')">
            {{ $t('reject') }}
          </button>
          <button class="clavo-button primary" @click="$emit('accept-invite')">
            {{ $t('joinNow') }}
          </button>
        </footer>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal'

export default {
  name: 'NewTeamMemberModal',
  components: {
    Modal,
  },
  props: {
    team: Object,
    acceptInvite: Boolean,
  },
}
</script>

<style scoped lang="scss">
.join-team-modal {
  .join-team-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    img {
      margin-top: 12px;
      margin-bottom: 36px;
      width: 240px;
    }
    footer {
      @include respond-below(xs) {
        width: 100%;
      }
      button {
        width: 145px;
        &:first-of-type {
          margin-right: 20px;
        }
        @include respond-below(xs) {
          display: block;
          width: 100%;
          &:first-of-type {
            margin-right: 0;
            margin-bottom: 12px;
          }
        }
      }
      &.single-btn {
        button {
          width: 306px;
        }
      }
    }
  }
}
</style>
